import { lazy } from "react";
import Loadable from "app/components/Loadable";

const DirectDepositPrepareMonthlyFile = Loadable(lazy(() => import("../components/DirectDepositPrepareMonthlyFile")));

const directDepositRoute = [{ path: "/supplements/direct-deposit", element: <DirectDepositPrepareMonthlyFile /> }];
export default directDepositRoute;
